import { PageDirections } from 'enums/PageDirections'
import { StateCreator } from 'zustand'

import { PageTransitionState } from './types'

export const createPageTransitionSlice: StateCreator<
  PageTransitionState,
  [],
  [],
  PageTransitionState
> = (set) => ({
  direction: PageDirections.FORWARD,

  setPageTransitionDirection: (direction) => set({ direction }),
})
